export default {
  'overview.enterpriseName': 'Enterprise Name',
  'overview.certNbr': 'Certification ID',
  'overview.address': 'Office Address',
  'overview.contactNumber': 'Contact Number',
  'overview.corporateLogo': 'Corporate Logo',
  'overview.upload.error': 'You can only upload JPG/PNG file!',
  'overview.upload.file.limit': 'Image must smaller than 2MB!',
  'overview.inProcessOrder': 'In-Process Order',
  'overview.totalAccount': 'Total Account',
  'overview.totalSubs': 'Total Subscriber',
  'overview.billAccount': 'Billing Account',
  'overview.billAmount': 'Billed Amount',
  'overview.unbilledAmount': 'Unbilled Amount',
  'overview.currentAmount': 'Current Amount',
  'overview.lastCycleConsumption': 'Last Cycle Consumption Overview',
  'overview.creditLimit': 'Credit Limit',
  'overview.totalAvailableCreditLimit': 'Total Available Credit Limit',
  'overview.totalCreditLimit': 'Total Credit Limit',
  'overview.usedCredit': 'Used Credit',
  'overview.currentBalance': 'Current Balance',
  'overview.usedBalance': 'Used Balance',
  'overview.data': 'Data',
  'overview.voice': 'Voice',
  'overview.sms': 'SMS',
  'overview.lastCycle': 'Last Cycle',
  'overview.updateSuccess': 'Update success.',
  'overview.currentCycle': 'Current Cycle',
  'overview.totalDataPool': 'Total Data Pool',
  'overview.remainingData': 'Remaining Data',
  'overview.dataPool': 'Data Pool',
  'overview.voicePool': 'Voice Pool',
  'overview.smsPool': 'SMS Pool',
  'overview.usedData': 'Used Data',
  'overview.usedVoiceData': 'Used Voice',
  'overview.usedSMSData': 'Used SMS',
  'overview.paymentAmountTips':
    'Supports inputting numbers and {displayScaleData} decimal places',
  'overview.paymentAmountTips1':
    'Please enter an integer between {minAmountData}-999999999.99',
  'overview.cscTT': 'CSC TT',
  'overview.active': 'Active',
  'overview.inactive': 'Inactive',
  'overview.suspension': 'Suspension',
  'overview.others': 'Others',
  'overview.processing': 'Processing',
  'overview.closed': 'Closed',
};
